import React from 'react';

// Este es un componente sustituto simple para next/image.
// Usa una etiqueta <img> estándar.
// Puedes extenderlo con más funcionalidades si lo necesitas (lazy loading, etc.).

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  // No se necesitan props especiales como `fill` o `quality` de Next.js
  // Se usan los atributos estándar de <img> como `src`, `alt`, `width`, `height`, `className`.
}

export const Image: React.FC<ImageProps> = ({ src, alt, className, ...props }) => {
  return <img src={src} alt={alt} className={className} {...props} />;
};

export default Image;
